import {observer} from 'mobx-react';
import React from 'react';

import {TrackerInitializer} from '@udemy/event-tracking';
import {Footer} from '@udemy/footer';
import {Header} from '@udemy/react-header';
import {Toaster} from '@udemy/react-messaging-components';
import {useStores} from '@udemy/store-provider';

import {RootStore} from 'src/stores/root-store';

import styles from './layout.module.less';

export const getLayout = (page: React.ReactElement) => {
    return <Layout>{page}</Layout>;
};

const Layout = observer(({children}: {children: React.ReactElement}) => {
    const [rootStore] = useStores([RootStore]);
    return (
        <>
            <div className={styles['container']}>
                <Header {...rootStore.headerData} showSmartBar={false} />
                <main className={styles['content']} id="main-content-anchor">
                    {children}
                </main>
                <Footer clientProps={rootStore.footerData} serverProps={rootStore.footerData} />
                <Toaster />
            </div>
            <TrackerInitializer />
        </>
    );
});
